module.exports = __webpack_public_path__ + "img/health.7f7f3a06.png";